<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-新建会议-添加
    -->
    <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

      <!-- <el-form-item label="新建会议名称" prop="name"><el-input v-model="form.name" placeholder="请输入新建会议名称" class="max-w460"></el-input></el-form-item> -->

      <div class="section-title">基本信息</div>

<el-form-item label="所属组织" prop="affiliated_organization">
  <el-select v-model="form.affiliated_organization" placeholder="请选择所属组织" class="max-w460">
    <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="会议分类" prop="meeting_category">
  <el-select v-model="form.meeting_category" placeholder="请选择会议分类" class="max-w460">
    <el-option v-for="item in conferenceClassificationList" :key="item.ma_conference_classification_id" :label="item.name" :value="item.ma_conference_classification_id"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="会议简介" prop="meeting_introduction">
  <el-input type="textarea" v-model="form.meeting_introduction" placeholder="请输入会议简介" class="max-w460"></el-input>
</el-form-item>
<el-form-item label="会议主持人" prop="meeting_host">
  <el-select v-model="form.meeting_host" placeholder="请选择会议主持人" class="max-w460" filterable>
    <el-option v-for="item in employeeList" :key="item.ma_yg_id" :label="item.name" :value="item.ma_yg_id"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="会议记录人" prop="meeting_recorder">
  <el-select v-model="form.meeting_recorder" placeholder="请选择会议记录人" class="max-w460" filterable>
    <el-option v-for="item in employeeList" :key="item.ma_yg_id" :label="item.name" :value="item.ma_yg_id"></el-option>
  </el-select>
</el-form-item>
<el-form-item label="会议时间" prop="meeting_time">
  <el-date-picker v-model="form.meeting_time" type="datetime" placeholder="请选择会议时间" class="max-w460"></el-date-picker>
</el-form-item>
<el-form-item label="参会人员" prop="participants">
  <el-input v-model="participantsText" placeholder="请选择参会人员" class="max-w460" readonly @click="openParticipantsDialog">
    <el-button slot="append" icon="el-icon-search" @click="openParticipantsDialog">选择</el-button>
  </el-input>
</el-form-item>
<el-form-item label="会议模式" prop="meeting_mode">
  <el-checkbox-group v-model="form.meeting_mode">
    <el-checkbox label="远程会议">远程会议</el-checkbox>
    <el-checkbox label="现场会议">现场会议</el-checkbox>
  </el-checkbox-group>
</el-form-item>

      <div class="section-title">会议内容</div>

<el-form-item label="会议视频" prop="meeting_video">
  <div class="draggable-list">
    <div v-if="form.meeting_video && form.meeting_video.length > 0">
      <div v-for="(item, index) in form.meeting_video" :key="index" class="item">
        <video v-if="item.file_path" :src="item.file_path" class="preview-video" controls></video>
        <div v-else class="preview-file">
          <i class="el-icon-video-camera"></i>
          <span>{{ item.name || '视频' }}</span>
        </div>
        <i class="el-icon-close delete-btn" @click="deleteMeetingVideo(index)"></i>
      </div>
    </div>
    <div class="item img-select" @click="openProductUpload('meeting_video')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item>

<el-form-item label="会议文档" prop="meeting_document">
  <div class="draggable-list">
    <div v-if="form.meeting_document && form.meeting_document.length > 0">
      <div v-for="(item, index) in form.meeting_document" :key="index" class="item">
        <div class="preview-file">
          <i class="el-icon-document"></i>
          <span>{{ item.name || '文档' }}</span>
        </div>
        <i class="el-icon-close delete-btn" @click="deleteMeetingDocument(index)"></i>
      </div>
    </div>
    <div class="item img-select" @click="openProductUpload('meeting_document')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item>

<el-form-item label="图片" prop="meeting_image">
  <div class="draggable-list">
    <div v-if="form.meeting_image && form.meeting_image.length > 0">
      <div v-for="(item, index) in form.meeting_image" :key="index" class="item">
        <img v-if="item.file_path" :src="item.file_path" alt="file_path"/>
        <div v-else class="preview-file">
          <i class="el-icon-picture"></i>
          <span>{{ item.name || '图片' }}</span>
        </div>
        <i class="el-icon-close delete-btn" @click="deleteMeetingImage(index)"></i>
      </div>
    </div>
    <div class="item img-select" @click="openProductUpload('meeting_image')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item>

<el-form-item label="会议地点" prop="meeting_place">
  <el-input v-model="form.meeting_place" placeholder="请输入会议地点" class="max-w460"></el-input>
</el-form-item>

<div class="section-title">文件上传</div>

<el-form-item label="上传文件" prop="attachments">
  <div class="draggable-list">
    <div v-if="form.attachments && form.attachments.length > 0">
      <div v-for="(item, index) in form.attachments" :key="index" class="item">
        <div class="preview-file">
          <i class="el-icon-document"></i>
          <span>{{ item.name || '文件' }}</span>
        </div>
        <i class="el-icon-close delete-btn" @click="deleteAttachment(index)"></i>
      </div>
    </div>
    <div class="item img-select" @click="openProductUpload('attachments')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item>

<el-form-item label="上传图片" prop="attachment_images">
  <div class="draggable-list">
    <div v-if="form.attachment_images && form.attachment_images.length > 0">
      <div v-for="(item, index) in form.attachment_images" :key="index" class="item">
        <img v-if="item.file_path" :src="item.file_path" alt="file_path"/>
        <div v-else class="preview-file">
          <i class="el-icon-picture"></i>
          <span>{{ item.name || '图片' }}</span>
        </div>
        <i class="el-icon-close delete-btn" @click="deleteAttachmentImage(index)"></i>
      </div>
    </div>
    <div class="item img-select" @click="openProductUpload('attachment_images')">
      <i class="el-icon-plus"></i>
    </div>
  </div>
</el-form-item>

<el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <el-dialog title="选择参会人员" :visible.sync="participantsDialogVisible" width="70%" append-to-body>
      <div class="participants-dialog">
        <el-form :inline="true" :model="employeeSearchForm" size="small">
          <el-form-item label="姓名">
            <el-input v-model="employeeSearchForm.name" placeholder="请输入姓名" clearable style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="employeeSearchForm.phone" placeholder="请输入手机号" clearable style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchEmployees">查询</el-button>
            <el-button @click="resetEmployeeSearch">重置</el-button>
          </el-form-item>
        </el-form>
        
        <div class="mb10">
          <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
          <span class="ml10">已选择 {{ selectedParticipants.length }} 人</span>
        </div>
        
        <el-table
          ref="employeeTable"
          :data="employeeList"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名" width="120"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
          <el-table-column prop="gender" label="性别" width="80">
            <template slot-scope="scope">
              {{ scope.row.gender === 1 ? '男' : '女' }}
            </template>
          </el-table-column>
          <el-table-column prop="department_name" label="部门"></el-table-column>
          <el-table-column prop="position_name" label="岗位"></el-table-column>
        </el-table>
        
        <div class="mt20 text-center">
          <el-pagination
            @size-change="handleEmployeeSizeChange"
            @current-change="handleEmployeeCurrentChange"
            :current-page="employeeCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="employeePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="employeeTotal">
          </el-pagination>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="participantsDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmParticipants">确定</el-button>
      </div>
    </el-dialog>
 </div>
</el-dialog>
  
</template>

<script>
import Ma_new_meetingApi from '@/api/ma_new_meeting.js';
import Ma_companyApi from '@/api/ma_company.js';
import Ma_conference_classificationApi from '@/api/ma_conference_classification.js';
import AfuncApi from '@/api/afunc.js';

import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,

     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,  
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        // categorya:{},
        sort:50,
        intro:"",
        bannar:[],
        meeting_mode: [],
        meeting_video: [],
        meeting_document: [],
        meeting_image: [],
        meeting_content: [],
        attachments: [],
        attachment_images: [],
        type: 1
      },
      loading: false,
      /*验证规则*/
      rules: {
        // name: [{ required: true, message: '请输入新建会议名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      companyList: [],
      conferenceClassificationList: [],
      employeeList: [],
      participantsDialogVisible: false,
      employeeSearchForm: {
        name: '',
        phone: ''
      },
      employeeCurrentPage: 1,
      employeePageSize: 10,
      employeeTotal: 0,
      selectedParticipants: [],
      selectAll: false,
      participantsText: ''
    };
  },
  computed: {
    dialogTitle() {
      return this.form.type === 1 ? '新增安全例会' : '新增补录例会';
    }
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    if (this.meeting_type) {
      this.form.type = this.meeting_type;
    }
    this.loadCompanies();
    this.loadConferenceClassifications();
    this.loadEmployees();
  },
  props: ["open_add", "meeting_type"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },

    loadCompanies() {
      let self = this;
      Ma_companyApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.companyList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    loadConferenceClassifications() {
      let self = this;
      Ma_conference_classificationApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.conferenceClassificationList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    loadEmployees() {
      let self = this;
      AfuncApi.call({
        model: 'ma_yg',
        action: 'getList',
        page: self.employeeCurrentPage,
        list_rows: self.employeePageSize,
        ...self.employeeSearchForm
      }).then(data => {
        if (data.code == 1) {
          self.employeeList = data.data.list.data || [];
          self.employeeTotal = data.data.list.total || 0;
          self.updateParticipantsText();
        }
      }).catch(error => {
        console.error('加载员工列表失败:', error);
      });
    },

    updateParticipantsText() {
      if (this.form.participants && Array.isArray(this.form.participants)) {
        const names = this.form.participants.map(id => {
          const employee = this.employeeList.find(emp => emp.ma_yg_id == id);
          return employee ? employee.name : id;
        });
        this.participantsText = names.join(', ');
      }
    },

    searchEmployees() {
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },

    resetEmployeeSearch() {
      this.employeeSearchForm = {
        name: '',
        phone: ''
      };
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },

    openParticipantsDialog() {
      this.participantsDialogVisible = true;
      this.loadEmployees();
    },

    handleSelectionChange(selection) {
      this.selectedParticipants = selection;
      this.selectAll = selection.length === this.employeeList.length && this.employeeList.length > 0;
    },

    handleSelectAll(val) {
      if (val) {
        this.$refs.employeeTable.toggleAllSelection();
      } else {
        this.$refs.employeeTable.clearSelection();
      }
    },

    handleEmployeeSizeChange(size) {
      this.employeePageSize = size;
      this.loadEmployees();
    },

    handleEmployeeCurrentChange(current) {
      this.employeeCurrentPage = current;
      this.loadEmployees();
    },

    confirmParticipants() {
      const names = this.selectedParticipants.map(item => item.name);
      const ids = this.selectedParticipants.map(item => item.ma_yg_id);
      this.form.participants = ids;
      this.participantsText = names.join(', ');
      this.participantsDialogVisible = false;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },


     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      //form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_new_meetingApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else if(this.code == 'meeting_video'){
        if (e != null) {
          let videoExpt = ["mp4"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            videoExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("视频类型有误,请选择mp4格式");
            return false;
          }

          let video = this.form.meeting_video.concat(e);
          this.$set(this.form, "meeting_video", video);
        }
      }else if(this.code == 'meeting_document'){
        if (e != null) {
          let docExpt = ["pdf"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            docExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("文档类型有误,请选择pdf格式");
            return false;
          }

          let document = this.form.meeting_document.concat(e);
          this.$set(this.form, "meeting_document", document);
        }
      }else if(this.code == 'meeting_image'){
        if (e != null) {
          let image = this.form.meeting_image.concat(e);
          this.$set(this.form, "meeting_image", image);
        }
      }else if(this.code == 'meeting_content'){
        if (e != null) {
          let content = this.form.meeting_content.concat(e);
          this.$set(this.form, "meeting_content", content);
        }
      }else if(this.code == 'attachments'){
        if (e != null) {
          let pdfExpt = ["pdf"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            pdfExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("文件类型有误,请选择pdf格式");
            return false;
          }

          let attachments = this.form.attachments.concat(e);
          this.$set(this.form, "attachments", attachments);
        }
      }else if(this.code == 'attachment_images'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true
                return false
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let images = this.form.attachment_images.concat(e);
          this.$set(this.form, "attachment_images", images);
        }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index,1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index,1);
      }
      
    },

    /*删除会议视频*/
    deleteMeetingVideo(index) {
      this.form.meeting_video.splice(index, 1);
    },

    /*删除会议文档*/
    deleteMeetingDocument(index) {
      this.form.meeting_document.splice(index, 1);
    },

    /*删除会议图片*/
    deleteMeetingImage(index) {
      this.form.meeting_image.splice(index, 1);
    },

    /*删除会议内容*/
    deleteMeetingContent(index) {
      this.form.meeting_content.splice(index, 1);
    },

    /*删除附件*/
    deleteAttachment(index) {
      this.form.attachments.splice(index, 1);
    },

    /*删除附件图片*/
    deleteAttachmentImage(index) {
      this.form.attachment_images.splice(index, 1);
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.participants-dialog {
  padding: 10px 0;
}

.mb10 {
  margin-bottom: 10px;
}

.mt20 {
  margin-top: 20px;
}

.ml10 {
  margin-left: 10px;
}

.text-center {
  text-align: center;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 20px 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-file {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.preview-file i {
  font-size: 32px;
  color: #999;
}

.preview-file span {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
  text-align: center;
}

.upload-buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.upload-item {
  display: inline-block;
}

.attachments-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

.attachment-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  max-width: 300px;
}

.attachment-icon {
  font-size: 20px;
  color: #409eff;
  margin-right: 8px;
}

.attachment-name {
  flex: 1;
  font-size: 13px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-delete {
  cursor: pointer;
  color: #999;
  font-size: 16px;
  margin-left: 8px;
}

.attachment-delete:hover {
  color: #f56c6c;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_new_meeting/index/part/add.vue